import { Component, OnInit } from "@angular/core";
import { GlobalUtilsService } from "../global-utils.service";
import { ActiveBreakpoint } from "../variables";

@Component({
  selector: "app-spotlight-section",
  templateUrl: "./spotlight-section.component.html",
  styleUrls: ["./spotlight-section.component.scss"],
})
export class SpotlightSectionComponent implements OnInit {
  private baseBgUrl: string = "../../assets/images/background";

  bgUrl: string;

  ActiveBreakpoint = ActiveBreakpoint;

  constructor(public globalUtilsService: GlobalUtilsService) {}

  ngOnInit() {
    this.bgUrl = this.getBgUrl();
  }

  getBackgroundStyle() {
    return {
      "background-image": `url(${this.bgUrl})`,
    };
  }

  // recupera um valor de 1 a 8 aleatoriamente
  private getRandomValue(): number {
    return Math.floor(Math.random() * 8) + 1;
  }

  private getBgUrl(): string {
    switch (this.globalUtilsService.activeScreen) {
      case ActiveBreakpoint.Desktop:
        return this.baseBgUrl + `/desktop/Image-0${this.getRandomValue()}.webp`;
      case ActiveBreakpoint.Tablet:
        return this.baseBgUrl + `/desktop/Image-0${this.getRandomValue()}.webp`;
      case ActiveBreakpoint.Mobile:
        return this.baseBgUrl + `/mobile/Image-0${this.getRandomValue()}.webp`;
      default:
        return this.baseBgUrl + `/desktop/Image-0${this.getRandomValue()}.webp`;
    }
  }
}
